import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

const Manual = props => {
  //meta title
  document.title = `${props.t("Manual")} | ${process.env.REACT_APP_CMS_TITLE}`

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Manual")}
            breadcrumbItem={props.t("Manual")}
          />
          {/* Add your manual content here */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Manual)
